import { BigNumber } from 'ethers';
import { createPlugin } from '../../../../Fct/createPlugin';
import { FctAddress, FctAddressList, FctTupleArray, FctValueList } from '../../../../Fct/generics';
import { getSupportedTokens } from '../../../../Fct/plugins/allowanceRequiredProtocols';
import { kiroboMulticallContracts } from '../constants';
//  'transfers_tuple[]': new FctTupleArray({ tupleParamsSchema:{ to: new FctAddressList({ key: 'to'}), amount: new FctValueList({ key: 'amount'})  } }),
// {
//   token: new FctAddress({}),
//   spender: new FctAddress({}),
//   amount: new FctValue({}),
// }
export var Erc20ApprovalsCSV = createPlugin({
    protocol: 'KIROBO_MULTICALL_CSV',
    type: 'LIBRARY',
    toEns: '@lib:multicall',
    method: 'erc20Approvals',
    name: 'erc20ApprovalsCSV',
    supportedContracts: kiroboMulticallContracts,
    getParams: function (_a) {
        var chainId = _a.chainId;
        return ({
            input: {
                to: new FctAddress({}),
                methodParams: {
                    'approvals_tuple[]': new FctTupleArray({
                        params: {
                            token: new FctAddressList({ options: getSupportedTokens({ chainId: chainId }) }),
                            spender: new FctAddressList({}),
                            amount: new FctValueList({}),
                        },
                    }),
                },
            },
            output: {},
        });
    },
    estimateGasOnParams: function (params, method, chainId) {
        // Gas notes:
        // 1 approve = 34000 gas
        var approvals_tuple = params.methodParams['approvals_tuple[]'];
        if (!approvals_tuple.value || !Array.isArray(approvals_tuple.value)) {
            return '10000';
        }
        var gas = BigNumber.from(approvals_tuple.value.length).mul(34000);
        if (chainId === '42161') {
            gas = gas.mul(13);
        }
        return gas.toString();
    },
});
